import { useContext, useEffect } from 'react';
import { useRecoilState } from 'recoil';
import { measurementAtom } from '../store/measurement';
import { DataContext } from '../../../entries/common/widgets/project-configuration/context';
import { ENDPOINTS } from '../const';

type TResult = {
  isLoading: boolean;
  isAvailable: boolean;
};

type TParams = {
  serviceId: string;
};

export const useMeasurement = ({ serviceId }: TParams): TResult => {
  const data = useContext(DataContext);
  const [measurement, setMeasurementState] = useRecoilState(measurementAtom);

  useEffect(() => {
    const api = data?.api;
    if (!__IS_SERVER__ && data?.regionId && api) {
      api
        .get(ENDPOINTS.GET_SERVICE({ serviceId, regionId: data.regionId }), {})
        .then(res => {
          setMeasurementState(prevState => ({
            ...prevState,
            ...res,
            isLoaded: true,
          }));
        })
        .catch(() => {
          setMeasurementState(prevState => ({
            ...prevState,
            isLoaded: true,
            isError: true,
          }));
        });
    }
  }, [data, serviceId, setMeasurementState]);

  return {
    isLoading: !measurement.isLoaded,
    isAvailable: measurement.isLoaded && !measurement.isError,
  };
};
